/*
//-------------------------------------------------------
//   Copyright (c) 2024 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     EPSignaturePad.js
//   Details:    EPSignaturePad.js
//
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// WI3713 31/01/24 JC       Added
//-------------------------------------------------------
*/

import React, { Component } from 'react';
import SignatureCanvas from 'react-signature-canvas'
import './css/EPSignaturePad.css';

class EPSignaturePad extends Component {
    sigPad = {}

    constructor(props) {
        super(props);

        this.state = {
            isEmpty: true,
            isEnabled: true
        };

        // attach handlers
        this.handleClear = this.handleClear.bind(this);
        this.handleAccept = this.handleAccept.bind(this);
        this.handleOnEnd = this.handleOnEnd.bind(this);
    }

    //handle clear
    handleClear = () => {
        //clear the pad
        this.sigPad.clear();

        //if we've got a handle image set method passed in then use
        if (this.props.handleImageSet !== undefined) {
            this.props.handleImageSet("");
        }

        //enable sig pad in case disabled
        this.sigPad.on()

        //flag as empty & enabled
        this.setState({
            isEmpty: true,
            isEnabled: true
        });

        //if we've got a handle image clear method passed in then use
        if (this.props.handleImageClear !== undefined) {
            this.props.handleImageClear();
        }
    }

    //handle accept
    handleAccept = () => {

        //get the image as base 64
        let base64Image = this.sigPad.getCanvas().toDataURL('image/png');

        //if we've got a handle image set method passed in then use
        if (this.props.handleImageSet !== undefined) {
            this.props.handleImageSet(base64Image);
        }

        //disable sig pad
        this.sigPad.off()

        //flag as disabled
        this.setState({
            isEnabled: false
        });
    }

    //handle on end
    handleOnEnd = () => {

        //get is empty status from canvas
        let isEmpty = this.sigPad.isEmpty();

        //set canvas is empty in state
        this.setState({
            isEmpty: isEmpty
        });
    }

    render() {

        let { isEmpty, isEnabled } = this.state;

        //default disabled to false
        let { disabled, signature } = this.props;
        if (disabled === undefined) { disabled = false; }

        //clear disabled = either disabled or empty
        let clearDisabled = disabled || isEmpty;

        //accept disabled = either disabled, empty, or not enabled
        let acceptDisabled = disabled || isEmpty || !isEnabled;

        return <div>
            {/* enabled? - show signature canvas & buttons */
                !disabled ?
                    <div>
                        <SignatureCanvas
                            canvasProps={{ className: 'sig-Pad' }}
                            backgroundColor="#cedffd"
                            ref={(ref) => { this.sigPad = ref }}
                            onEnd={this.handleOnEnd}
                        />
                        <div className="float-right">
                            <button key="clear" className="btn btn-default btn-dftleftpadding" disabled={clearDisabled} onClick={this.handleClear}>Clear</button>
                            <button key="accept" className="btn btn-default btn-dftleftpadding" disabled={acceptDisabled} onClick={this.handleAccept}>Accept</button>
                        </div>
                    </div>
                    :
                    /* otherwise show image, assuming we have one */
                    <div>
                        {signature !== undefined && signature !== null && signature.length > 0 ?
                            <img
                                className="img-responsive"
                                alt="Signature"
                                src={signature} /* note source is handled in props*/
                                style={{
                                    maxWidth: "100%"
                                }} 
                            />
                            : []}
                    </div>
            }
        </div>
    }

}

export default EPSignaturePad;
